<template>
  <button
    class="bb-button bb-description-3 bb-bold bb-fcenter"
    :class="{ '--selected': currentPage === page }"
    @click="$emit('click')"
  >
    {{ page }}
  </button>
</template>

<script>
  export default {
    props: {
      page: Number,
      currentPage: Number,
    },
  };
</script>

<style lang="scss" scoped>
  @import '~assets/styles/index.scss';
</style>
